import { Stack, Text } from '@mantine/core';
import { ControlledOptionsSwitcher } from '@/app/components/shared/navigation/OptionsSwitcher';
import { SimpleSlider } from '@/app/components/shared/form/slider/SimpleSlider';
import { SettingTitle } from '../../../components/SettingTitle';
import { useFormContext } from '../../../contexts/formContext';
import { OnOffSetting } from '../../../components/OnOffSetting';

const path = 'assetSimplification.materialAndTextureBaking';
export function MaterialAndTextureBaking() {
  const form = useFormContext();

  return (
    <Stack gap='xs'>
      <SettingTitle
        title='Texture Baking Quality'
        description='Choose the texture baking quality. Higher values lead to longer baking times'
      />
      <ControlledOptionsSwitcher
        options={[
          { label: 'Low', value: 'low' },
          { label: 'Medium', value: 'medium' },
          { label: 'High', value: 'high' },
        ]}
        onChanged={(option) => form.setFieldValue(`${path}.bakingQuality`, option)}
        value={form.values.assetSimplification?.materialAndTextureBaking.bakingQuality}
      />
      <OnOffSetting
        description='Select if a new normal map should be baked'
        mt='sm'
        title={'Bake Normal Map'}
        initialOption={form.values.assetSimplification?.materialAndTextureBaking.bakeNormalMap ?? false}
        onChanged={(option) => form.setFieldValue(`${path}.bakeNormalMap`, option)}
      />
      <OnOffSetting
        mt='sm'
        title='Bake AO Map'
        description='Select if a new AO map should be baked'
        initialOption={form.values.assetSimplification?.materialAndTextureBaking.bakeAOMap ?? false}
        onChanged={(option) => form.setFieldValue(`${path}.bakeAOMap`, option)}
      />
      <Stack gap='xs' mt='sm'>
        <SettingTitle title='AO Baking Strength' description='Strength (intensity) for generated AO maps' />
        <SimpleSlider
          min={0}
          max={1}
          step={0.01}
          marks={[
            {
              label: '0',
              value: 0,
            },
            {
              label: '0.5',
              value: 0.5,
            },
            {
              label: '1',
              value: 1,
            },
          ]}
          w={400}
          {...form.getInputProps(`${path}.aoStrength`)}
        />
      </Stack>
      <Stack gap='xs' mt='sm'>
        <SettingTitle
          title='Alpha map to opaque threshold'
          description='Consider the material opaque if the alpha map mean value is above the given value'
        />
        <SimpleSlider
          min={0}
          max={1}
          step={0.01}
          marks={[
            {
              label: '0',
              value: 0,
            },
            {
              label: '0.5',
              value: 0.5,
            },
            {
              label: '1',
              value: 1,
            },
          ]}
          w={400}
          {...form.getInputProps(`${path}.alphaMapToOpaqueThreshold`)}
        />
      </Stack>
    </Stack>
  );
}
